<template>
<el-dialog :visible.sync="dialogVisible" top="0" width="709px" :before-close="closeModal">
    <AlertExclamationRegister size="40" color="#FFAC00" class="d-flex mt-5 mb-2 mx-auto"/>
    <h3 class="c-ndarkthree bold text-center mb-2">
        Deseja enviar o cadastro para análise?
    </h3>
    <p class="c-ndarkfour text-center">
        Assim que você concluir o cadastro da empresa, a nossa equipe irá validar os dados<br>
        que você inseriu. Enquanto isso, você não poderá modificar nenhuma informação<br>
        ou documento anexado. Deseja continuar mesmo assim?
    </p>
    <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">
        <router-link to="" @click.native="gotoPartners" :class="`${getPrimaryColor} c-ndarkfour mr-4`" v-if="this.$route.params.id && !this.complementaryRegister">
            Cadastrar procuradores
        </router-link>
        <router-link to="" @click.native="closeModal"  :class="`${getPrimaryColor} c-ndarkfour mr-4`" v-else>
            Cancelar
        </router-link>
        <button :class="`btn btn-${getPrimaryColor}`" @click="changeRegisterStatus">
            Ok, enviar 
        </button>
    </span>
</el-dialog>
</template>

<script>
import AlertExclamationRegister from '@/components/icons/AlertExclamationRegister'
import updateRegisterStatusCompany from '@/api/updateRegisterStatusCompany'
import updateCompanyComplementaryRegister from '@/api/updateCompanyComplementaryRegister'
import userRules from '@/api/userRules'
export default {
    components: {
      AlertExclamationRegister
    },
    props: {
        dialogVisible: {
            required: true,
            type: Boolean,
            default: false
        },
        complementaryRegister: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {}
    },
    methods: {
        gotoPartners() {
            this.$store.commit('tabs/setPartnerTab', '1')
            this.$router.push(`/company/register/${this.$route.params.idCNPJ}/partner`)
        },
        closeModal() {
            this.$emit('closeModal', false)
        },
        async changeRegisterStatus() {
            this.$emit('closeModal', false)
            const STATUS_IN_ANALYSIS = 2
            const finishReview = true
            if (this.complementaryRegister) {
                await updateCompanyComplementaryRegister(this.$route.params.idCNPJ, { complementaryRegister: true })
            }
            const result = await updateRegisterStatusCompany(this.$route.params.idCNPJ, { status: STATUS_IN_ANALYSIS, finishReview }, this.getWhiteLabel)
            if (result.ok) {
                await userRules()
                this.$router.push(`/company/register/${this.$route.params.idCNPJ}/message?status=${STATUS_IN_ANALYSIS}`)
            }
        }
    },
}
</script>

<style>
</style>